import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'SelectServiceScreenModal',
  components: {
    Loading
  },
  data () {
    return {
      loading: true,

      // テーブルオプション
      tableColumns: [
        'screenCode',
        'screenName',
        'isReleased',
        'selectButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          screenCode: '画面構成ID',
          screenName: '画面構成名',
          isReleased: 'ステータス',
          selectButton: ''
        },
        columnsClasses: {
          screenCode: 'wp-5',
          screenName: '',
          isReleased: '',
          selectButton: 'wp-5'
        },
        sortable: [
          'screenCode',
          'screenName',
          'isReleased'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts('画面'),
        perPage: Constants.TableOptions.perPage.modal,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      serviceId: state => state.selectServiceScreenModal.serviceId,
      screenModel: state => state.selectServiceScreenModal.screenModel,
      active: state => state.selectServiceScreenModal.active,
      overlay: state => state.selectServiceScreenModal.overlay
    }),
    ...mapGetters({
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'selectServiceScreenModal/loadModel',
      hide: 'selectServiceScreenModal/hide',
      setValue: 'selectServiceScreenModal/setValue',
      reset: 'selectServiceScreenModal/reset'
    }),

    init () {
      this.loading = true

      // storeをリセット
      this.reset()

      //
      let serviceContentsParams = {
        serviceUuid: this.serviceId
      }

      // データ読出し
      this.loadModel({
        serviceContentsParams: serviceContentsParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.screenModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'isReleased':
          return Utility.getConstantsLabel(['ScreenSetting', 'Released'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    selectItem (props) {
      // console.log(props.row)

      // 選択されたファイル情報をstoreに保持
      this.setValue(props.row)

      this.closeModal()
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}